<h2 class="">
  Michigan Public Service Commission</h2>


<!-- Modal to display when there are errors -->
<div class="modal" tabindex="-1" role="dialog"  [ngStyle]="{'display':displayModal}">
 <div class="modal-dialog" role="document">
   <div class="modal-content">
     <div class="modal-header">
       <h4 class="modal-title">Error</h4>
     </div>
     <div class="modal-body">
       <p>{{errorMessage}}</p>
     </div>
     <div class="modal-footer">
       <button type="button" class="btn btn-primary"  aria-label="Close" (click)="modalOpenClose()">Close</button>
     </div>
   </div>
 </div>
</div>



<div class="col-sm-12 well padding-bottom-20" *ngIf="!completionPage">
  <div class=" row col-sm-12 col-sm-no-padding-sides">
    <h3 class="col-sm-11"> Legally Enforceable Obligation (LEO) Review Request Form</h3>
  </div>

  <div class="col-sm-12 mt-3 no-padding-sides">
    <p class="text-justify">
      The purpose of this form is to initiate an Expedited Legally Enforceable Obligation (LEO) Review Process with
      Michigan Public Service Commission Staff pursuant to the Commission’s July 7, 2021 Order in Case No. U-20905.
    </p>
    <p class="text-justify">
      Please note that any documents submitted to Staff may become a public record for the purposes of Freedom of
      Information Act (FOIA).
    </p>

    <h3 class="text-center"> Contact Information </h3>

    <form>
    <div class="row col-sm-12 mt-3 padding-right">
      <!--DEVELOPER NAME-->
      <div class="form-group col-lg-4">
        <label for="developerName" class="control-label required"> Developer Name</label>
        <input type="text" class="form-control" id="developerName" [formControl]="leoForm.controls['developerName']"
          [(ngModel)]="leoData.developerName" required name="developerName">
        <div *ngIf="(leoForm?.controls['developerName']?.errors?.required || leoForm?.controls['developerName']?.errors?.isValid)
                      && leoForm?.controls['developerName']?.touched" class="error-msg">
          Developer Name is Required.
        </div>
        <div *ngIf="leoForm?.controls['developerName']?.errors?.maxlength" class="error-msg">
          Developer Name cannot be more than 200 characters.
        </div>
      </div>
      <!--ADDRESS-->
      <div class="form-group col-lg-4">
        <label for="address1" class="control-label required">Address</label>
        <input type="text" class="form-control" id="address1" [formControl]="leoForm.controls['address1']"
          [(ngModel)]="leoData.address1" name="address1">
        <div
          *ngIf="(leoForm?.controls['address1']?.errors?.required || leoForm?.controls['address1']?.errors?.isValid) && leoForm?.controls['address1']?.touched"
          class="error-msg">
          Address is Required.
        </div>
        <div *ngIf="leoForm?.controls['address1']?.errors?.maxlength" class="error-msg">
          Address cannot be more than 200 characters.
        </div>
      </div>
      <!--ADDRESS 2-->
      <div class="form-group col-lg-4">
        <label for="address2" class="control-label">Address 2</label>
        <input type="text" class="form-control" id="address2" [formControl]="leoForm.controls['address2']"
          [(ngModel)]="leoData.address2" name="address2">
        <div *ngIf="leoForm?.controls['address2']?.errors?.maxlength"
          class="error-msg">
          Address 2 cannot be more than 200 characters.
        </div>
      </div>
    </div>


    <div class="row col-sm-12 mt-3 padding-right">
      <!--CITY-->
      <div class="form-group col-lg-4">
        <label for="city" trim="blur" class="control-label required">City </label>
        <input type="text" class="form-control" id="city" [formControl]="leoForm.controls['city']"
          [(ngModel)]="leoData.city" required name="city">
        <div
          *ngIf="(leoForm?.controls['city']?.errors?.required || leoForm?.controls['city']?.errors?.isValid) && leoForm?.controls['city']?.touched"
          class="error-msg">
          City is Required.
        </div>
        <div *ngIf="leoForm?.controls['city']?.errors?.maxlength" class="error-msg">
          City cannot be more than 100 characters.
        </div>
      </div>
      <!--STATE-->
      <div class="form-group col-lg-4">
        <label for="state" class="control-label required">State </label>
        <select name="state" id="state" class="form-control" [formControl]="leoForm.controls['state']"
          [(ngModel)]="leoData.state" required>
          <option *ngFor="let state of allStates" [value]="state.stateName">{{state.stateName}}</option>
        </select>
        <div
          *ngIf="(leoForm?.controls['state']?.errors?.required || leoForm?.controls['state']?.errors?.isValid) && leoForm?.controls['state']?.touched"
          class="error-msg">
          State is Required.
        </div>
      </div>
      <!--ZIP-->
      <div class="form-group col-lg-4">
        <label for="zip" class="control-label required">Zip </label>
        <input type="text" class="form-control" id="zip" [formControl]="leoForm.controls['zip']"
          [(ngModel)]="leoData.zip" placeholder="12345 or 12345-6789" required name="zip">
        <div
          *ngIf="(leoForm?.controls['zip']?.errors?.required || leoForm?.controls['zip']?.errors?.isValid) && leoForm?.controls['zip']?.touched"
          class="error-msg">
          Zip is Required.
        </div>
        <div
          *ngIf="leoData.zip !='undefined' && leoData.zip != null && leoData.zip != '' && leoForm?.controls['zip']?.errors?.invalidZip && leoForm?.controls['zip']?.touched"
          class="error-msg">
          Please enter a valid zip.
        </div>
      </div>
    </div>


    <div class="row col-sm-12 mt-3 padding-right">
      <!--CONTACT PERSON-->
      <div class="form-group col-lg-4">
        <label for="contactPerson" class="control-label required"> Contact Person</label>
        <input type="text" class="form-control" id="contactPerson" [formControl]="leoForm.controls['contactPerson']"
          [(ngModel)]="leoData.contactPerson" required name="contactPerson">
        <div *ngIf="(leoForm?.controls['contactPerson']?.errors?.required || leoForm?.controls['contactPerson']?.errors?.isValid)
                      && leoForm?.controls['contactPerson']?.touched" class="error-msg">
          Contact Person is Required.
        </div>
        <div *ngIf="leoForm?.controls['contactPerson']?.errors?.maxlength" class="error-msg">
          Contact Person cannot be more than 200 characters.
        </div>
      </div>
      <!--CONTACT PHONE-->
      <div class="form-group col-lg-4">
        <label for="contactPhone" class="control-label required">Contact Phone</label>
        <input type="text" [mask]="phoneMask" class="form-control" id="contactPhone"
          [formControl]="leoForm.controls['contactPhone']" [(ngModel)]="leoData.contactPhone" name="contactPhone">
        <div
          *ngIf="(leoForm?.controls['contactPhone']?.errors?.required || leoForm?.controls['contactPhone']?.errors?.isValid) && leoForm?.controls['contactPhone']?.touched"
          class="error-msg">
          Contact Phone is Required.
        </div>
        <div
          *ngIf="leoData.contactPhone !='undefined' && leoData.contactPhone != null && leoData.contactPhone != '' && leoForm?.controls['contactPhone']?.errors?.invalidPhone && leoForm?.controls['contactPhone']?.touched"
          class="error-msg">
          Please enter a valid Contact Phone.
        </div>
      </div>
      <!--DIRECT EMAIL-->
      <div class="form-group col-lg-4">
        <label for="directEmail" class="control-label required">Direct Email</label>
        <input type="text" class="form-control" id="directEmail" [formControl]="leoForm.controls['directEmail']"
          [(ngModel)]="leoData.directEmail" required name="directEmail">
        <div *ngIf="leoForm?.controls['directEmail']?.errors?.required && leoForm?.controls['directEmail']?.touched"
          class="error-msg">
          Direct Email is Required.
        </div>
        <div *ngIf="leoForm?.controls['directEmail']?.errors?.maxlength" class="error-msg">
          Direct Email cannot be more than 200 characters.
        </div>
        <div
          *ngIf="leoData.directEmail !='undefined' && leoData.directEmail != null && leoData.directEmail != '' && leoForm?.controls['directEmail']?.errors?.email && leoForm?.controls['directEmail']?.touched"
          class="error-msg">
          Please enter valid Direct Email.
        </div>
      </div>
    </div>


    <div class="row col-sm-12 mt-3 padding-right">
      <!--DOCKET FILING NUMBER-->
      <div class="form-group col-lg-4">
        <label for="docketFilingNumber" class="control-label required"> Form 556 QF Docket Filing Number</label>
        <input type="text" class="form-control" id="docketFilingNumber"
          [formControl]="leoForm.controls['docketFilingNumber']" [(ngModel)]="leoData.docketFilingNumber" required
          name="docketFilingNumber">
        <div *ngIf="(leoForm?.controls['docketFilingNumber']?.errors?.required || leoForm?.controls['docketFilingNumber']?.errors?.isValid)
                      && leoForm?.controls['docketFilingNumber']?.touched" class="error-msg">
          Form 556 QF Docket Filing Number is Required.
        </div>
        <div
          *ngIf="leoData.docketFilingNumber !='undefined' && leoData.docketFilingNumber != null && leoData.docketFilingNumber != '' && leoForm?.controls['docketFilingNumber']?.errors?.docketFilingNumberValid && leoForm?.controls['docketFilingNumber']?.touched"
          class="error-msg">
          Form 556 QF Docket Filing Number must start with QF- and be followed by a docket number that is a minimum of 6 characters and a maximum of 12 characters.
        </div>
      </div>
    </div>


    <h3 class="text-center"> Description of Project </h3>


    <div class="row col-sm-12 mt-3 padding-right">
      <!--INTERCONNECTING UTILITY-->
      <div class="form-group col-lg-6">
        <label for="interconnectingUtility" class="control-label required"> Name of Interconnecting Utility</label>
        <input type="text" class="form-control" id="interconnectingUtility"
          [formControl]="leoForm.controls['interconnectingUtility']" [(ngModel)]="leoData.interconnectingUtility"
          required name="interconnectingUtility">
        <div *ngIf="(leoForm?.controls['interconnectingUtility']?.errors?.required || leoForm?.controls['interconnectingUtility']?.errors?.isValid)
                      && leoForm?.controls['interconnectingUtility']?.touched" class="error-msg">
          Name of Interconnecting Utility is Required.
        </div>
        <div *ngIf="leoForm?.controls['interconnectingUtility']?.errors?.maxlength" class="error-msg">
          Name of Interconnecting Utility cannot be more than 200 characters.
        </div>
      </div>
      <!--PROJECT SIZE-->
      <div class="form-group col-lg-6">
        <label for="projectSize" class="control-label required"> Project Size in MWac</label>
        <input type="text" class="form-control" id="projectSize" [formControl]="leoForm.controls['projectSize']"
          [(ngModel)]="leoData.projectSize" required name="projectSize">
        <div *ngIf="(leoForm?.controls['projectSize']?.errors?.required || leoForm?.controls['projectSize']?.errors?.isValid)
                      && leoForm?.controls['projectSize']?.touched" class="error-msg">
          Project Size in MWac is Required.
        </div>
        <div *ngIf="leoForm?.controls['projectSize']?.errors?.maxlength" class="error-msg">
          Project Size in MWac cannot be more than 100 characters.
        </div>
      </div>    
    </div>


    <div class="row col-sm-12 mt-3 padding-right">
      <!--DATE FILED-->
      <div class="form-group col-lg-6">
        <label for="dateFiled" class="control-label required">Date Application was Filed with Utility</label>
        <input type="date" class="form-control" id="dateFiled" placeholder=""
          [formControl]="leoForm.controls['dateFiled']" [(ngModel)]="leoData.dateFiled" name="dateFiled"
          max="9999-12-31">
        <div
          *ngIf="leoForm?.controls['dateFiled']?.errors?.required && leoForm?.controls['dateFiled']?.touched"
          class="error-msg">
          Date Application was Filed with Utility is required
        </div>
        <div
          *ngIf="leoForm?.controls['dateFiled']?.errors?.validDateFormat && leoForm?.controls['dateFiled']?.touched"
          class="error-msg">
          Please enter valid date(MM/DD/YYYY)
        </div>
      </div>
      <!--UTILITY IDENTIFICATION-->
      <div class="form-group col-lg-6">
        <label for="utilityIdentification" class="control-label">Utility Interconnection Identification</label>
        <input type="text" class="form-control" id="utilityIdentification" [formControl]="leoForm.controls['utilityIdentification']"
          [(ngModel)]="leoData.utilityIdentification" name="utilityIdentification">
        <div *ngIf="leoForm?.controls['utilityIdentification']?.errors?.maxlength"
          class="error-msg">
          Utility Interconnection Identification cannot be more than 100 characters.
        </div>
      </div>      
    </div>


    <div class="row col-sm-12 mt-3 padding-right">
      <!--TECHNOLOGY TYPE-->
      <div class="form-group col-lg-6">
        <label for="technologyType" class="control-label required"> Technology Type</label>
        <input type="text" class="form-control" id="technologyType" [formControl]="leoForm.controls['technologyType']"
          [(ngModel)]="leoData.technologyType" required name="technologyType">
        <div *ngIf="(leoForm?.controls['technologyType']?.errors?.required || leoForm?.controls['technologyType']?.errors?.isValid)
                      && leoForm?.controls['technologyType']?.touched" class="error-msg">
          Technology Type is Required.
        </div>
        <div *ngIf="leoForm?.controls['technologyType']?.errors?.maxlength" class="error-msg">
          Technology Type cannot be more than 200 characters.
        </div>
      </div>
      <!--COUNTY-->
      <div class="form-group col-lg-6">
        <label for="county" class="control-label required">Michigan county where the project is located </label>
        <select name="county" id="county" class="form-control" [formControl]="leoForm.controls['county']"
          [(ngModel)]="leoData.county" required>
          <option *ngFor="let county of allCounties" [value]="county.countyName">{{county.countyName}}</option>
        </select>
        <div
          *ngIf="(leoForm?.controls['county']?.errors?.required || leoForm?.controls['county']?.errors?.isValid) && leoForm?.controls['county']?.touched"
          class="error-msg">
          Michigan county where the project is located is Required.
        </div>
      </div>
    </div>


    <div class="row col-sm-12 mt-3 padding-right">
      <!--DESCRIPTION OF PROJECT-->
      <div class="form-group col-sm-12">
        <label for="descriptionOfProject" class="control-label required"> Description of Project</label>
        <textarea type="textarea" rows="10" class="form-control min-height-100" id="descriptionOfProject"
          [formControl]="leoForm.controls['descriptionOfProject']" [(ngModel)]="leoData.descriptionOfProject" required
          name="descriptionOfProject"></textarea>
        <div *ngIf="(leoForm?.controls['descriptionOfProject']?.errors?.required || leoForm?.controls['descriptionOfProject']?.errors?.isValid)
                      && leoForm?.controls['descriptionOfProject']?.touched" class="error-msg">
          Description of Project is Required.
        </div>
        <div *ngIf="leoForm?.controls['descriptionOfProject']?.errors?.maxlength" class="error-msg">
          Description of Project cannot be more than 1000 characters.
        </div>
      </div>
    </div>


    <h3 class="text-center">Description of LEO</h3>


    <div class="row col-sm-12 mt-3 padding-right">
      <!--DATE ESTABLISHED LEO-->
      <div class="form-group col-lg-6">
        <label for="dateEstablishedLeo" class="control-label required min-height-45-large">Date the QF believes it has established an
          LEO</label>       
        <input type="date" class="form-control" id="dateEstablishedLeo" placeholder=""
          [formControl]="leoForm.controls['dateEstablishedLeo']" [(ngModel)]="leoData.dateEstablishedLeo"
          name="dateEstablishedLeo" max="9999-12-31">
        <div
          *ngIf="leoForm?.controls['dateEstablishedLeo']?.errors?.required && leoForm?.controls['dateEstablishedLeo']?.touched"
          class="error-msg">
          This field is required.
        </div>        
        <div
          *ngIf="leoForm?.controls['dateEstablishedLeo']?.errors?.validDateFormat && leoForm?.controls['dateEstablishedLeo']?.touched"
          class="error-msg">
          Please enter valid date(MM/DD/YYYY).
        </div>
      </div>
      <!--SEEKING LEO FOR ENERGY OR CAPACITY-->
      <div class="form-group col-lg-6">
        <label for="seekingLeoForEnergyOrCapacity" class="control-label required min-height-45-large"> Is the QF seeking an LEO for energy
          and/or capacity?</label>
        <input type="text" class="form-control" id="seekingLeoForEnergyOrCapacity"
          [formControl]="leoForm.controls['seekingLeoForEnergyOrCapacity']"
          [(ngModel)]="leoData.seekingLeoForEnergyOrCapacity" required name="seekingLeoForEnergyOrCapacity">
        <div *ngIf="(leoForm?.controls['seekingLeoForEnergyOrCapacity']?.errors?.required || leoForm?.controls['seekingLeoForEnergyOrCapacity']?.errors?.isValid)
                      && leoForm?.controls['seekingLeoForEnergyOrCapacity']?.touched" class="error-msg">
          This field is Required.
        </div>
        <div *ngIf="leoForm?.controls['seekingLeoForEnergyOrCapacity']?.errors?.maxlength" class="error-msg">
          This field cannot be more than 200 characters.
        </div>
      </div>
    </div>


    <div class="row col-sm-12 mt-3 padding-right">
        <!--STEPS TO MEET CRITERIA-->      
      <div class="form-group col-sm-12">
        <label for="stepsToMeetCriteria" class="control-label required"> Please describe the steps taken by the QF to
          meet the approved LEO criteria for the utility. Include specific dates.</label>
        <textarea type="textarea" class="form-control min-height-100" id="stepsToMeetCriteria"
          [formControl]="leoForm.controls['stepsToMeetCriteria']" [(ngModel)]="leoData.stepsToMeetCriteria" required
          name="stepsToMeetCriteria"></textarea>
        <div *ngIf="(leoForm?.controls['stepsToMeetCriteria']?.errors?.required || leoForm?.controls['stepsToMeetCriteria']?.errors?.isValid)
                      && leoForm?.controls['stepsToMeetCriteria']?.touched" class="error-msg">
          Description of steps taken is Required.
        </div>
        <div *ngIf="leoForm?.controls['stepsToMeetCriteria']?.errors?.maxlength" class="error-msg">
          This field cannot be more than 1000 characters.
        </div>
      </div>
    </div>


    <div class="row col-sm-12 mt-3 padding-right">
        <!--GOOD FAITH EFFORT-->      
      <div class="form-group col-sm-12">
        <label for="goodFaithEffort" class="control-label required"> Please describe good faith effort to communicate
          an intent to enter into a contract or establish an LEO with the utility. Include specific dates.</label>
        <textarea type="textarea" class="form-control min-height-100" id="goodFaithEffort" [formControl]="leoForm.controls['goodFaithEffort']"
          [(ngModel)]="leoData.goodFaithEffort" required name="goodFaithEffort"></textarea>
        <div *ngIf="(leoForm?.controls['goodFaithEffort']?.errors?.required || leoForm?.controls['goodFaithEffort']?.errors?.isValid)
                      && leoForm?.controls['goodFaithEffort']?.touched" class="error-msg">
          Description of good faith effort is Required.
        </div>
        <div *ngIf="leoForm?.controls['goodFaithEffort']?.errors?.maxlength" class="error-msg">
          This field cannot be more than 1000 characters.
        </div>
      </div>
    </div>


    <div class="row col-sm-12 mt-3 padding-right">
      <!--NATURE OF CONFLICT-->
      <div class="form-group col-sm-12">
        <label for="natureOfConflict" class="control-label required"> Please describe the nature of the conflict
          between the QF and the utility.</label>
        <textarea type="textarea" class="form-control min-height-100" id="natureOfConflict"
          [formControl]="leoForm.controls['natureOfConflict']" [(ngModel)]="leoData.natureOfConflict" required
          name="natureOfConflict"></textarea>
        <div *ngIf="(leoForm?.controls['natureOfConflict']?.errors?.required || leoForm?.controls['natureOfConflict']?.errors?.isValid)
                      && leoForm?.controls['natureOfConflict']?.touched" class="error-msg">
          Description of nature of the conflict between the QF and the utility is Required.
        </div>
        <div *ngIf="leoForm?.controls['natureOfConflict']?.errors?.maxlength" class="error-msg">
          This field cannot be more than 1000 characters.
        </div>
      </div>
    </div>


    <div class="row mt-3 col-xs-12 padding-right">
      <div class="col-xs-12 mt-3 text-center">
        <input type="submit" (click)="saveLeo()" class="btn btn-primary offset1" value="Submit">
      </div>
    </div>

  </form>
  </div>
</div>




















<div class ="container" *ngIf="completionPage" >
  <div class="col-sm-12">
   <strong class="col-sm-12 text-center">Here is the information you have submitted.</strong>
   <strong class="col-sm-12 text-center">A copy of this information will be emailed to {{leoData.directEmail}}.</strong>
  </div>

<div class="col-sm-12 mt-5">
<table class="table table-striped table-bordered col-sm-12"role='presentation' >

 <tbody>
       <tr>
           <th class="col-sm-4">
           </th>
           <th class="col-sm-8">
           </th>
       </tr>
   <tr>
     <td>Company Name:</td>
     <td>{{leoData.developerName}}</td>
   </tr>
   <tr>
     <td>Address:</td>
     <td>{{leoData.address1}}</td>
   </tr>
   <tr>
     <td>Address 2:</td>
     <td>{{leoData.address2}}</td>
   </tr>
    <tr>
     <td>City:</td>
     <td>{{leoData.city}}</td>
   </tr>
  <tr>
     <td>State:</td>
      <td>{{leoData.state}}</td>
   </tr>
   <tr>
     <td>Zip:</td>
      <td>{{leoData.zip}}</td>
   </tr>
   <tr>
     <td>Contact Person:</td>
      <td>{{leoData.contactPerson}}</td>
   </tr>
    <tr>
     <td>Contact Phone:</td>
      <td>{{leoData.contactPhone}}</td>
   </tr>
  <tr>
     <td>Direct Email:</td>
      <td>{{leoData.directEmail}}</td>
   </tr>
   <tr>
     <td>Form 556 QF Docket Filing Number:</td>
      <td>{{leoData.docketFilingNumber}}</td>
   </tr>
   <tr>
     <td>Name of Interconnecting Utility:</td>
      <td> {{leoData.interconnectingUtility}}</td>
   </tr>
   <tr>
     <td>Project Size in MWac:</td>
      <td>{{leoData.projectSize}}</td>
   </tr>   
  <tr>
     <td>Date application was filed with utility:</td>
      <td>{{leoData.dateFiled}}</td>
   </tr>
   <tr>
    <td>Utility Interconnection Identification:</td>
     <td>{{leoData.utilityIdentification}}</td>
  </tr>
   <tr>
     <td>Technology Type:</td>
      <td>{{leoData.technologyType}}</td>
   </tr>
   <tr>
     <td>Michigan county where the project is located:</td>
      <td>{{leoData.county }}  </td>
   <tr>
     <td>Description of Project:</td>
      <td>{{leoData.descriptionOfProject}}</td>
   </tr>
   <tr>
     <td>Date the QF believes it has established an LEO:</td>
      <td>{{leoData.dateEstablishedLeo}}</td>
   </tr>
   <tr>
     <td>Is the QF seeking an LEO for energy and/or capacity?:</td>
      <td>{{leoData.seekingLeoForEnergyOrCapacity}}</td>
   </tr>
     <tr>
     <td>Please describe the steps taken by the QF to meet the approved LEO criteria for the utility. Include specific dates.:</td>
      <td>{{leoData.stepsToMeetCriteria}}</td>
   </tr>
   <tr>
     <td>Please describe good faith effort to communicate an intent to enter into a contract or establish an LEO with the utility. Include specific dates.:</td>
      <td>{{leoData.goodFaithEffort}}</td>
   </tr>
   <tr>
     <td>Please describe the nature of the conflict between the QF and the utility.:</td>
      <td style="word-break:break-all;">{{leoData.natureOfConflict}}</td>
   </tr>
 </tbody>
</table>
 </div>
<div class="form-group col-sm-12 text-center">
   <!-- <button type="button" (click)="Menu()" class="btn btn-dark">Back To Menu</button> -->
       <button type="goBack" (click)="goBack()" class="btn btn-primary offset1">Back to LEO Form</button>
     </div>

  </div>

